import { computed, ref, Ref } from '@vue/composition-api';
import i18n, { i18n_t } from '@/locales/i18n';
import { SelectableFileItem } from '@/renderer/components/drawer/compositions/selectableFileItem';
import { FileType } from '@/renderer/components/drawer/compositions/fileType';
class FileSelectHandler {
  // 是否展示文件列表
  readonly shouldShowFileSelector: Ref<Boolean> = ref(false);

  // 文件列表
  readonly fileList: Ref<Array<SelectableFileItem>> = ref([]);

  // 所有的过滤类型
  readonly allFileTypeList = computed(() => this.uniqueTypeList(this.fileList.value.map(it => it.fileType)));

  // 用户手动选择的过滤类型
  readonly manulFilterTypeList: Ref<Array<FileType> | null> = ref(null);

  // 展示的过滤类型
  readonly filterFileTypeList: Ref<Array<FileType>> = ref([]);

  // 更新展示的过滤类型
  updateFilterFileTypeList(manulFilterTypeList: Array<FileType> | null, allFileTypeList: Array<FileType>) {
    this.filterFileTypeList.value = manulFilterTypeList ?? allFileTypeList;
  }

  // 过滤后的文件列表
  readonly filteredFileList: Ref<Array<SelectableFileItem>> = computed(() =>
    this.fileList.value.filter(it => this.filterFileTypeList.value.includes(it.fileType)),
  );

  // 选中的文件
  readonly selectedFile: Ref<SelectableFileItem | null> = ref(null);

  // 选中文件的下标
  readonly selectedIndex = computed(this.createSelectedIndex());

  // 更新配置
  updateSelectConfig(config: Drawer.FileListSwitchConfig): void {
    this.fileList.value = config.fileList.map(it => new SelectableFileItem(it));
    this.selectedFile.value = new SelectableFileItem(config.selectedFile);
    if (config.shouldResetFilter) {
      this.manulFilterTypeList.value = null;
    }
  }
  private readonly uniqueTypeList = (typeList: Array<FileType>): Array<FileType> =>
    [...new Set(typeList)].sort((lhs, rhs) => lhs - rhs);

  // 创建selectedIndex, 处理out scope this
  private createSelectedIndex() {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    return {
      get() {
        if (!self.selectedFile.value) return -1;
        const fileItem = self.selectedFile.value as SelectableFileItem;
        return self.filteredFileList.value.map(it => it.file.name).indexOf(fileItem.file.name);
      },
      set(val: number) {
        const list = self.filteredFileList.value;
        if (list.length <= val) return;
        self.selectedFile.value = list[val];
      },
    };
  }
}
function fileTypeToWording(fileType: FileType): string {
  switch (fileType) {
    case FileType.All:
      return i18n_t('全部');
    case FileType.Audio:
      return i18n_t('音频');
    case FileType.Picture:
      return i18n_t('图片');
    case FileType.Document:
      return i18n_t('文档');
    case FileType.Video:
      return i18n_t('视频');
    case FileType.Others:
      return i18n_t('其他');
    default:
      return FileType[fileType];
  }
}
export { SelectableFileItem, FileType, FileSelectHandler, fileTypeToWording };
